@if (isEditMode) {
  <div class="table-content" title="{{cellValue}}">
    <input list="datalist" class="form-control datalist-input">
    <datalist id="datalist" [(ngModel)]="lookupKeyVal" (change)="changeAction($event)" >
      <option value="Select a option">
        @for (lookupItem of lookupArray; track lookupItem) {
          <option value="{{lookupItem[column.lookupDescKey]}}">
            <!-- <option *ngFor="let lookupItem of lookupArray" [value]="lookupItem.primaryKey">{{lookupItem[column.lookupDescKey]}}</option> -->
          }
          <!-- <option *ngFor="let lookupItem of lookupArray" [value]="lookupItem.primaryKey">{{lookupItem[column.lookupDescKey]}}</option> -->
        </datalist>
      </div>
    }

    @if (!isEditMode) {
      <div class="table-content" title="{{cellValue}}" (dblclick)="dbClickAction()">
        {{cellValue}}
      </div>
    }
